'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { Paper } from '../Paper/Paper';
import { styled } from '@mui/material/styles';
import { getElevation } from '../helpers/getElevation';
const StyledCard = styled(Paper)({});
export const Card = React.forwardRef(({ raised = false, variant, ...props }, ref) => (_jsx(StyledCard, { elevation: getElevation(raised, variant), ref: ref, variant: variant, ...props })));
Card.displayName = 'Card';
